import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { Navigate } from 'react-router-dom'
import { GET_VARIANT_OPTION_GROUPS } from '../graphql/product-queries'
import VariantOptionGroupForm from '../components/VariantOptionGroupForm'
import LoadingSpinner from '../components/LoadingSpinner'

const EditVariantOptionGroupPage = () => {
  const { id } = useParams<{ id: string }>()

  const { data, loading, error } = useQuery(GET_VARIANT_OPTION_GROUPS, {
    variables: { filters: {} }
  })

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (error || !data?.variantOptionGroups) {
    return <Navigate to="/variant-option-groups" replace />
  }

  const variantOptionGroup = data.variantOptionGroups.find((vog: any) => vog.id === parseInt(id!))

  if (!variantOptionGroup) {
    return <Navigate to="/variant-option-groups" replace />
  }

  return <VariantOptionGroupForm variantOptionGroup={variantOptionGroup} isEdit={true} />
}

export default EditVariantOptionGroupPage

